module.exports = __webpack_public_path__ + "img/PSpearman64_ua.a0db9936.webp";